exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.teammate-photo{\r\n    width: 100%;\r\n    object-fit: cover;\n}\n.teammate-btn{\r\n    margin: 12px 0px;\r\n    background: #fff;\r\n    border: none;\r\n    text-align: center;\r\n    padding: 10px;\r\n    cursor: pointer;\n}\n.teammate-bio{\r\n    padding-bottom: 25px;\n}\n.link{\r\n    text-align: center;\r\n    width: 100%;\r\n    color: #2196f3;\r\n    cursor: pointer;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-cbe8c03e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/meet-the-team/teammate.vue
// module id = 648
// module chunks = 0